<template>
	<div>
		<j-list :list="computedGrossPremium" class="bb1 bc7">
			<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
				<div class="flex xs-6 xs-left xs-middle fw7 c1 lh125">
					{{ item.label }}
					<j-button
						v-if="hasPremiumActions"
						v-can:or="['writeQuotes', 'writePolicies']"
						size="xsmall"
						class="ml2"
						type="fifth"
						@click="$modal.show(`edit_gross_premium_${id}`)"
					>{{ $t("edit_gross_premium") }}</j-button>
				</div>
				<div class="flex xs-6 xs-right xs-middle lh125">{{ item.value }}</div>
			</div>
		</j-list>

		<core-modal
			:name="`edit_gross_premium_${id}`"
			:headline="$t('edit_gross_premium')"
		>
			<div class="p4">
				<div class="lh150">
					<div class="lh150">
						<span class>{{ $t("edit_gross_premium_description") }}</span>
						<p
							class="pt2 pb2"
						>{{ $t("gross_premium") }}: {{ computedGrossPremium[0].value }}</p>
					</div>
				</div>
				<update-premium
					type="gross"
					:isLoading="isLoading"
					:amount="originalPrice"
					@created="onUpdatePremium"
					@cancelled="$modal.hide(`edit_gross_premium_${id}`)"
				/>
			</div>
		</core-modal>
	</div>
</template>

<script>
import CoreModal from "@/modules/core/components/CoreModal"
import JList from "@/components/JList"
import JButton from "@/components/JButton"

import UpdatePremium from "./UpdatePremium"

export default {
	components: {
		CoreModal,
		JButton,
		JList,
		UpdatePremium
	},
	props: {
		id: {
			type: String
		},
		pricing: {
			type: Object
		},
		hasPremiumActions: {
			type: Boolean
		},
		onUpdatePremium: {
			type: Function
		},
		isLoading: {
			type: Boolean
		}
	},
	computed: {
		originalPrice() {
			return this.pricing.originalPrice
		},
		computedGrossPremium() {
			return [
				{
					label: this.$t("gross_premium"),
					value: this.pricing?.formattedOriginalPrice
				}
			]
		}
	}
}
</script>

<style>
</style>